'use client';

import {
  SubNavigation as V3SubNavigation,
  SubNavigationProps,
} from '@stadionhq-v3/base-ui';
import classnames from 'classnames';
import styles from './subNavigation.module.scss';

export const SubNavigation = ({
  classNames,
  items,
  onDark = false,
  theme,
  ...props
}: SubNavigationProps) => {
  const classes = classnames(
    [
      styles.tokens,
      styles.subNavigation,
      ...(theme ? [styles[theme.themeId]] : []),
      onDark ? styles.onDark : styles.onLight,
    ],
    classNames
  );

  return (
    <V3SubNavigation
      classNames={[classes]}
      onDark={onDark}
      theme={theme}
      items={items.map((subNavItem) => ({
        ...subNavItem,
        linkProps: {
          ...subNavItem.linkProps,
          classNames: [
            classnames(
              styles.subNavigationItem,
              subNavItem.selected && styles.subNavigationItemSelected
            ),
          ],
        },
      }))}
      {...props}
    />
  );
};
